import type { MutableRefObject } from "react";

import { applyTimelineStageViewCss } from "@/lib/timeline/view/StageViewCss/css";
import type { TimelineViewTransform } from "@/lib/timeline/view/ViewTransform/transform";

export function applyStagePanUnlock(
  next: TimelineViewTransform,
  stage: HTMLElement | null,
  viewRef: MutableRefObject<TimelineViewTransform>,
  panBreakRef: MutableRefObject<boolean>,
  restoredHoldRef: MutableRefObject<boolean>,
  setViewTransform: (next: TimelineViewTransform) => void,
  onUnlock?: (next: TimelineViewTransform) => void,
): void {
  restoredHoldRef.current = false;
  panBreakRef.current = true;
  viewRef.current = next;
  applyTimelineStageViewCss(stage, next);
  setViewTransform(next);
  onUnlock?.(next);
}
